import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["moduleKey"],
  _excluded2 = ["target"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { confluenceExtensionURLHelpers, confluenceNavigationTargetURLHelpers } from './navigation-targets/confluence';
import { getModuleByKey, NavigationError } from './navigation-targets/common';
import { jiraExtensionURLHelpers, jiraNavigationTargetHandlers } from './navigation-targets/jira';
import { ensureURLPath } from './createMakeProductURLPath';
var extensionURLHelpers = _objectSpread(_objectSpread({}, confluenceExtensionURLHelpers), jiraExtensionURLHelpers);
var navigationTargetHandlers = _objectSpread(_objectSpread(_objectSpread({}, jiraNavigationTargetHandlers), confluenceNavigationTargetURLHelpers), {}, {
  userProfile: function () {
    var _userProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var accountId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            accountId = _ref.accountId;
            return _context.abrupt("return", ensureURLPath("/people/".concat(accountId)));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function userProfile(_x) {
      return _userProfile.apply(this, arguments);
    }
    return userProfile;
  }(),
  module: function () {
    var _module = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, _ref3) {
      var getAppForgeUIExtensions, moduleKey, params, module, moduleUrlHelper;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            getAppForgeUIExtensions = _ref3.getAppForgeUIExtensions;
            moduleKey = _ref2.moduleKey, params = _objectWithoutProperties(_ref2, _excluded);
            if (moduleKey) {
              _context2.next = 4;
              break;
            }
            throw NavigationError.MissingProperty('moduleKey');
          case 4:
            _context2.next = 6;
            return getModuleByKey(getAppForgeUIExtensions, moduleKey);
          case 6:
            module = _context2.sent;
            if (!(!module || !module.appId || !module.environmentId)) {
              _context2.next = 9;
              break;
            }
            throw NavigationError.ModuleNotFound(moduleKey);
          case 9:
            moduleUrlHelper = extensionURLHelpers[module.type];
            if (moduleUrlHelper) {
              _context2.next = 12;
              break;
            }
            throw NavigationError.NotSupportedExtensionType(module.type);
          case 12:
            return _context2.abrupt("return", moduleUrlHelper(module, params));
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function module(_x2, _x3) {
      return _module.apply(this, arguments);
    }
    return module;
  }()
});
export var createNavigateTargetUrl = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(targetInfo, utils) {
    var target, payload, handler;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          target = targetInfo.target, payload = _objectWithoutProperties(targetInfo, _excluded2);
          handler = navigationTargetHandlers[target];
          if (handler) {
            _context3.next = 4;
            break;
          }
          return _context3.abrupt("return", null);
        case 4:
          _context3.prev = 4;
          _context3.next = 7;
          return handler(payload, utils);
        case 7:
          return _context3.abrupt("return", _context3.sent);
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](4);
          // eslint-disable-next-line no-console
          console.error(_context3.t0.message);
          return _context3.abrupt("return", null);
        case 14:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[4, 10]]);
  }));
  return function createNavigateTargetUrl(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();